import { getRequestEvent, isServer } from "solid-js/web";

export function isNativeApp(platform?: string) {
  if (isServer) {
    const userAgent =
      getRequestEvent()?.request.headers.get("user-agent")?.toLowerCase() ?? "";
    return (
      userAgent.includes("radiojhero/") &&
      (platform ? userAgent.includes(`(${platform})`) : true)
    );
  }

  const className = platform ? `native-${platform}` : "native";
  return globalThis.document.documentElement.classList.contains(className);
}
